export enum MemoSignatureStatusUpdateAction {
  SIGNED = "SIGNED",
  REJECTED = "REJECTED",
}

export enum MemoSignatureCustomFieldType {
  DATE = "date",
  TEXT = "text",
  INITIALS = "initials",
}
